import request from '@/utils/request'

export function getCategories(params) {
  params = {...params, 'multysearch[status.statusId]': '1,2'}
  return request({
    url: '/api/product_categories',
    method: 'get',
    params
  })
}

export function getCategory(id, params) {
  return request({
    url: `/api/product_categories/${id}`,
    method: 'get',
    params
  })
}

export function putCategory(id, data) {
  return request({
    url: `/api/product_categories/${id}`,
    method: 'put',
    data
  })
}

export function postCategory(data) {
  return request({
    url: '/api/product_categories',
    method: 'post',
    data
  })
}

export function deleteCategory(id) {
  return request({
    url: `/api/product_categories/${id}`,
    method: 'delete'
  })
}

export function getMeasures(params) {
  return request({
    url: '/api/units',
    method: 'get',
    params
  })
}

export function postMeasures(data) {
  return request({
    url: '/api/units',
    method: 'post',
    data
  })
}

export function getMeasure(id, params) {
  return request({
    url: `/api/units/${id}`,
    method: 'get',
    params
  })
}

export function putMeasure(id, data) {
  return request({
    url: `/api/units/${id}`,
    method: 'put',
    data
  })
}

export function deleteMeasure(id) {
  return request({
    url: `/api/units/${id}`,
    method: 'delete'
  })
}

export async function getPlaces(params) {
  params = {...params, tmp: false, 'order[sortNumber]': 'asc'}
  return request({
    url: '/api/storages',
    method: 'get',
    params
  })
}

export function getPlace(id, params) {
  return request({
    url: `/api/storages/${id}`,
    method: 'get',
    params
  })
}

export function postPlace(data) {
  return request({
    url: '/api/storages',
    method: 'post',
    data
  })
}

export function putPlace(id, data) {
  return request({
    url: `/api/storages/${id}`,
    method: 'put',
    data
  })
}

export function deletePlace(id) {
  return request({
    url: `/api/storages/${id}`,
    method: 'delete'
  })
}

export function getGoods(params) {
  params = {...params, 'multysearch[status.statusId]': '1,2'}
  return request({
    url: '/api/products',
    method: 'get',
    params
  })
}

export function getGoodsItem(id, params) {
  return request({
    url: `/api/products/${id}`,
    method: 'get',
    params
  })
}

export function postGoods(data) {
  return request({
    url: '/api/products',
    method: 'post',
    data
  })
}

export function postGoodsMove(data) {
  return request({
    url: '/api/products/move',
    method: 'post',
    data
  })
}

export function putGoodsItem(id, data) {
  return request({
    url: `/api/products/${id}`,
    method: 'put',
    data
  })
}

export function deleteGoodsItem(id) {
  return request({
    url: `/api/products/${id}`,
    method: 'delete'
  })
}

export function getReport(params) {
  return request({
    url: '/api/storage/history',
    method: 'get',
    params
  })
}

export function getGoodStorages(params) {
  params = {...params, 'storage.tmp': false}
  return request({
    url: '/api/product_storages',
    method: 'get',
    params
  })
}

export function getHistory(params) {
  return request({
    url: '/api/storage_orders',
    method: 'get',
    params
  })
}





// WEBPACK FOOTER //
// ./src/modules/productsStorage/api.js